<template>
  <div>
  <b-modal
    id="modal-update-issue-multi-einvoice"
    centered
    hide-header
  >
    <b-card-header class="banned-background-color-primary">
      <div class="d-flex justify-content-between align-items-center block-header">
        <div class="d-flex justify-content-start align-items-center">
          <p class="mb-0 title-modal color-primary mr-1">
            {{ $t('golf_booking_detail_publish_einvoice') }}
          </p>
        </div>
        <feather-icon
          icon="XIcon"
          size="24"
          class="cursor-pointer color-primary"
          @click="hideModal"
        />
      </div>
    </b-card-header>
    <b-card-body>
        <div class="header">
            <div class="header-name">
              {{ getMemberPay() }}
            </div>
            <div class="header-amount">
              {{ totalAmountPaymentBaseCurrDisplay }}
              <ez-icon
              v-if = "!isShowDetailListInvoice"
                click
                style="margin-left: 5px;"
                icon="ezGolf-icon-chevron-down"
                :size="20"
                @click ="showListDetailInvoice"

              />
              <ez-icon
                v-if = "isShowDetailListInvoice"
                style="margin-left: 5px;"
                icon="ezGolf-icon-chevron-up"
                :size="20"
                @click ="showListDetailInvoice"
              />
            </div>
          </div>
          <div 
          class="detail-invoice"  
          ref="refDetaiInvoice"
          v-show ="isShowDetailListInvoice"

          >
            <div class="detail-invoice-item"
              v-for="(payment, index) in listPayment" 
                :key="payment.Id"
          >
           
      <div class=" d-flex justify-content-between">
        <div>
          <span style="display: block;"><strong>{{ index + 1 }}.</strong> {{ getInvoiceText(payment) }} </span>
          <span style="display: block;"> {{ getInvoiceClient(payment) }}</span>
        </div>
        
        <span>{{formatPrice(payment.TotalAmount)  }} </span>
      </div>
          </div>
          </div>
      <b-row class="mb-50">
        <b-col>
          <div class="d-flex justify-content-start align-items-center">
          <p class="span-header-info">
            {{ $t('golf_booking_detail_info_publish_einvoice') }}
          </p>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-50">
          <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <b-form-checkbox v-model="isCheckVisitorNoInvoice" @change="changeCheckVisitorNoInvoice(isCheckVisitorNoInvoice)">
            </b-form-checkbox>
           </div>
           <div class="form-group-einvoice">
                    <span class="span-text-einvoice">
              {{ $t('golf_sidebar_merge_visitor_no_invoice') }}
            </span>
                    </div>
          </b-col>
      </b-row>
      <b-row class="mb-50">
        <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <span class="span-text-einvoice">
              {{ $t('golf_booking_detail_guest_take_einvoice') }}
            </span>
          </div>
              <div class="form-group-einvoice">
                    <b-form-input
                    v-model="BookingDetail.GuestNameTakeInvoice"
                    :placeholder="$t('golf_booking_detail_guest_take_einvoice')"
                        />
                    </div>

                  </b-col>
          </b-row>
          <b-row class="mb-50">
        <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <span class="span-text-einvoice">
              {{  $t('golf_common_client') }}
            </span>
          </div>
              <div class="form-group-einvoice">
                        <v-select
                            v-model="BookingDetail.ClientDefaultId"
                            :options="companies"
                            label="ClientName"
                            :reduce="option => option.Id"
                            :disabled="isCheckVisitorNoInvoice"
                            :placeholder="$t('golf_common_client')"
                            @input="onChangeClient()"
                          />
                    </div>

                  </b-col>
          </b-row>
          <b-row class="mb-50">
        <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <span class="span-text-einvoice">
              {{ $t('golf_tax_invoice_company_name') }}
            </span>
          </div>
              <div class="form-group-einvoice">
                        <b-form-input
                         v-model="BookingDetail.CompanyName"
                         :disabled="isCheckVisitorNoInvoice"
                         :placeholder="$t('golf_tax_invoice_company_name')"
                        />
                    </div>

                  </b-col>
          </b-row>
          <b-row class="mb-50">
        <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <span class="span-text-einvoice">
              {{ $t('golf_booking_detail_guest_address') }}
            </span>
          </div>

              <div class="form-group-einvoice">
                        <b-form-input
                        v-model="BookingDetail.CompanyAddress"
                        :disabled="isCheckVisitorNoInvoice"
                          :placeholder="$t('golf_booking_detail_guest_address')"
                        />
                    </div>

                  </b-col>
          </b-row>
          <b-row class="mb-50">
        <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <span class="span-text-einvoice">
              {{ $t('golf_member_member_id') }}
            </span>
          </div>
              <div class="form-group-einvoice">
                        <b-form-input
                        v-model="BookingDetail.IdentityCardTakeInvoice"
                        :disabled="isCheckVisitorNoInvoice"
                        :placeholder="$t('golf_member_member_id')"
                        />
                    </div>

                  </b-col>
          </b-row>
          <b-row class="mb-50">
        <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <span class="span-text-einvoice">
              {{ $t('golf_tax_invoice_tax_code') }}
            </span>
          </div>
              <div class="form-group-einvoice">
                        <b-form-input
                        v-model="BookingDetail.TaxCode"
                        :disabled="isCheckVisitorNoInvoice"
                        :placeholder="$t('golf_tax_invoice_tax_code')"
                        />
                    </div>

                  </b-col>
          </b-row>
          <b-row class="mb-50">
        <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <span class="span-text-einvoice">
              {{  $t('golf_common_phone')  }}
            </span>
          </div>
              <div class="form-group-einvoice">
                        <b-form-input
                        v-model="BookingDetail.GuestPhoneTakeInvoice"
                        :disabled="isCheckVisitorNoInvoice"
                        :placeholder="$t('golf_common_phone')"
                        />
                    </div>

                  </b-col>
          </b-row>
          <b-row class="mb-50">
        <b-col cols="12" md="12" class="d-flex" >
          <div class="span-group-einvoice d-flex align-content-center" >
            <span class="span-text-einvoice">
              {{$t('golf_tax_invoice_company_email') }}
            </span>
          </div>
              <div class="form-group-einvoice">
                        <b-form-input
                        v-model="BookingDetail.GuestEmailTakeInvoice"
                        :disabled="isCheckVisitorNoInvoice"
                          :placeholder="$t('golf_tax_invoice_company_email')"
                        />
                    </div>

                  </b-col>
          </b-row>
    </b-card-body>
    <template #modal-footer>
      <div class="">
        <b-button
          size="md"
          class="float-right ml-1"
          @click="hideModal"
        >
        {{ $t('golf_common_back') }}
        </b-button>
        <b-button
          variant="primary"
          size="md"
          class="float-right"
          @click="UpdateInfoGuest()"
          :disabled="disableButton"
        >
          {{ $t('golf_payment_publish_einvoice') }}
          <b-spinner
          v-if="disableButton"
          small
          label="Loading..."
        />
        </b-button>
      </div>
    </template>
  </b-modal>
</div>
</template>
<script>
import { booking } from '@/api/booking'
import { members } from '@/api/members'

export default {
  props: [
      'listPayment',
  ],
  data() {
      return {
        fullNameDefaultVisitorNoInvoice: null,
        PaymentId: null,
        isCheckVisitorNoInvoice:false,
        BookingDetailDefaul:{},
        BookingDetail: {
          Id: null,
          GuestNameTakeInvoice: null,
          IsGuestTakeInvoice: true,
          CompanyName: '',
          CompanyAddress: '',
          TaxCode: '',
          GuestEmailTakeInvoice: '',
          GuestPhoneTakeInvoice: '',
          ClientDefaultId: null
        },
        disableButton: false,
        companies:[],
        isShowDetailListInvoice: false,
      
      }
  },
  created() {
    this.getConfigInfo_RCOM01()
  },
  computed: {
    // paymentTypeOptions() {
    //   return [
    //     { title: this.$t('golf_common_payment'), value: PaymentTypeCode.Payment },
    //     { title: this.$t('golf_common_refund'), value: PaymentTypeCode.Refund },
    //   ]
    // },
    getInvoiceText() {
      return (payment) => {
        return `Hóa đơn #${payment.Id} - ${payment.FullName}${payment.BDC ? " #" + payment.BDC : ""}${payment.Bagtag ? " @" + payment.Bagtag : ""}`;
      };
    },
    getInvoiceClient() {
      return (payment) => {
        return `${payment.ClientId ? payment.ClientId +"-" + payment.ClientName : ""}`;
      };
    },
    totalAmountPaymentBaseCurr() {
      if (this.listPayment) {
        return this.listPayment.reduce((sum, item) => sum + (item.TotalAmount ), 0)
      }
      return 0
    },
    totalAmountPaymentBaseCurrDisplay() {
      return `${this.formatPrice(this.totalAmountPaymentBaseCurr)}`
    },
  },
  watch: {
    listPayment(value) {
           this.open(value[0])
      },
    isCheckVisitorNoInvoice(value) {
      if (!value) {

      this.BookingDetail.IsGuestTakeInvoice = true
      this.BookingDetail.GuestNameTakeInvoice = this.BookingDetailDefaul.FullName;
      this.BookingDetail.CompanyName = this.BookingDetailDefaul.CompanyName
      this.BookingDetail.CompanyAddress = this.BookingDetailDefaul.CompanyAddress
      this.BookingDetail.TaxCode = this.BookingDetailDefaul.TaxCode
      this.BookingDetail.GuestEmailTakeInvoice = this.BookingDetailDefaul.GuestEmailTakeInvoice
      this.BookingDetail.GuestPhoneTakeInvoice = this.BookingDetailDefaul.GuestPhoneTakeInvoice
      this.BookingDetail.IdentityCardTakeInvoice = this.BookingDetailDefaul.IdentityCardTakeInvoice

      if( this.BookingDetail.CompanyName == null || this.BookingDetail.CompanyName === ""){
        if(this.BookingDetailDefaul.ClientId != null){
          this.BookingDetail.CompanyName = this.companies.find(x => x.Id == this.BookingDetailDefaul.ClientId).InvoiceName ? this.companies.find(x => x.Id ==this.BookingDetailDefaul.ClientId).InvoiceName : ''
      this.BookingDetail.CompanyAddress = this.companies.find(x => x.Id == this.BookingDetailDefaul.ClientId).Address1
      this.BookingDetail.GuestPhoneTakeInvoice = this.companies.find(x => x.Id == this.BookingDetailDefaul.ClientId).Tel1
      this.BookingDetail.TaxCode = this.companies.find(x => x.Id == this.BookingDetailDefaul.ClientId).TaxCode
      this.BookingDetail.GuestEmailTakeInvoice = this.companies.find(x => x.Id == this.BookingDetailDefaul.ClientId).Email
        }
      }
      
      this.BookingDetail.GuestNameTakeInvoice = 
      (this.BookingDetail.GuestNameTakeInvoice != null && this.BookingDetail.GuestNameTakeInvoice.trim() !== "")  
      ? this.BookingDetail.GuestNameTakeInvoice : this.BookingDetail.FullName
      

    } else {

      this.BookingDetail.IsGuestTakeInvoice = false
      this.BookingDetail.GuestNameTakeInvoice =this.fullNameDefaultVisitorNoInvoice
      this.BookingDetail.CompanyName = null
      this.BookingDetail.CompanyAddress = null
      this.BookingDetail.TaxCode = null
      this.BookingDetail.GuestEmailTakeInvoice = null
      this.BookingDetail.GuestPhoneTakeInvoice = null
      this.BookingDetail.ClientDefaultId = null
      this.BookingDetail.IdentityCardTakeInvoice = null

    }
    }
  },
  methods: {
    async open(item) {
      if(item){
        this.BookingDetailDefaul=item
      await this.getCompanies_RCL01(item.OpenDateTime)
      this.isCheckVisitorNoInvoice=false
      this.BookingDetail.Id = item.BookingDetailId
      this.BookingDetail.GuestNameTakeInvoice = item.GuestNameTakeInvoice !== null ? item.GuestNameTakeInvoice : item.FullName;
      this.BookingDetail.IsGuestTakeInvoice = true
      this.BookingDetail.CompanyName = item.CompanyName
      this.BookingDetail.CompanyAddress = item.CompanyAddress
      this.BookingDetail.TaxCode = item.TaxCode
      this.BookingDetail.GuestEmailTakeInvoice = item.GuestEmailTakeInvoice
      this.BookingDetail.GuestPhoneTakeInvoice = item.GuestPhoneTakeInvoice
      this.BookingDetail.IdentityCardTakeInvoice = item.IdentityCardTakeInvoice
      this.PaymentId = item.Id
      if( this.BookingDetail.CompanyName == null || this.BookingDetail.CompanyName === ""){
        if(item.ClientId != null){
          this.BookingDetail.CompanyName = this.companies.find(x => x.Id == item.ClientId).InvoiceName ? this.companies.find(x => x.Id ==item.ClientId).InvoiceName : ''
      this.BookingDetail.CompanyAddress = this.companies.find(x => x.Id == item.ClientId).Address1
      this.BookingDetail.GuestPhoneTakeInvoice = this.companies.find(x => x.Id == item.ClientId).Tel1
      this.BookingDetail.TaxCode = this.companies.find(x => x.Id == item.ClientId).TaxCode
      this.BookingDetail.GuestEmailTakeInvoice = this.companies.find(x => x.Id == item.ClientId).Email
        }
      }
      
      this.BookingDetail.GuestNameTakeInvoice = 
      (this.BookingDetail.GuestNameTakeInvoice != null && this.BookingDetail.GuestNameTakeInvoice.trim() !== "")  
      ? this.BookingDetail.GuestNameTakeInvoice : this.BookingDetail.FullName
      }
       
      
      //this.$bvModal.show('modal-update-issue-multi-einvoice')
  },
  changeCheckVisitorNoInvoice(value) {
    // if (!value) {
    //   console.log(this.BookingDetailDefaul)
    //   this.BookingDetail.IsGuestTakeInvoice = true
    //   this.BookingDetail.GuestNameTakeInvoice = this.BookingDetailDefaul.FullName;
    //   this.BookingDetail.CompanyName = this.BookingDetailDefaul.CompanyName
    //   this.BookingDetail.CompanyAddress = this.BookingDetailDefaul.CompanyAddress
    //   this.BookingDetail.TaxCode = this.BookingDetailDefaul.TaxCode
    //   this.BookingDetail.GuestEmailTakeInvoice = this.BookingDetailDefaul.GuestEmailTakeInvoice
    //   this.BookingDetail.GuestPhoneTakeInvoice = this.BookingDetailDefaul.GuestPhoneTakeInvoice
    // } else {
    //   this.BookingDetail.IsGuestTakeInvoice = false
    //   this.BookingDetail.GuestNameTakeInvoice =this.fullNameDefaultVisitorNoInvoice
    //   this.BookingDetail.CompanyName = null
    //   this.BookingDetail.CompanyAddress = null
    //   this.BookingDetail.TaxCode = null
    //   this.BookingDetail.GuestEmailTakeInvoice = null
    //   this.BookingDetail.GuestPhoneTakeInvoice = null
    //   this.BookingDetail.ClientDefaultId = null
    // }
      
  },
  showListDetailInvoice(){
    this.isShowDetailListInvoice = ! this.isShowDetailListInvoice
  },
  getMemberPay() {
      if (this.listPayment) {
        return `${this.$t('golf_sidebar_checkout_list_order')}: ${this.listPayment.length} ${this.$t('golf_payment_invoice')}`
      }
      return ''
    },
  onChangeClient() {
      if(this.BookingDetail.ClientDefaultId != null) {
        this.BookingDetail.CompanyName = this.companies.find(x => x.Id == this.BookingDetail.ClientDefaultId).InvoiceName ? this.companies.find(x => x.Id == this.BookingDetail.ClientDefaultId).InvoiceName : ''
        this.BookingDetail.CompanyAddress = this.companies.find(x => x.Id == this.BookingDetail.ClientDefaultId).Address1
        this.BookingDetail.GuestPhoneTakeInvoice = this.companies.find(x => x.Id == this.BookingDetail.ClientDefaultId).Tel1
        this.BookingDetail.TaxCode = this.companies.find(x => x.Id == this.BookingDetail.ClientDefaultId).TaxCode
        this.BookingDetail.GuestEmailTakeInvoice = this.companies.find(x => x.Id == this.BookingDetail.ClientDefaultId).Email
      }
      else{
        // this.data.BookingDetail.CompanyName = ''
        // this.data.BookingDetail.CompanyAddress = ''
        // this.data.BookingDetail.TaxCode = ''
        // this.data.BookingDetail.GuestEmailTakeInvoice = ''
        // this.data.BookingDetail.GuestPhoneTakeInvoice = ''
      }
    },
      hideModal() {
          this.$bvModal.hide('modal-update-issue-multi-einvoice')
      },
      async UpdateInfoGuest() {
    const body = {
      BookingDetail: {
          Id: 0,
          GuestNameTakeInvoice: this.BookingDetail.GuestNameTakeInvoice,
          IsGuestTakeInvoice: this.BookingDetail.IsGuestTakeInvoice,
          CompanyName: this.BookingDetail.CompanyName,
          CompanyAddress: this.BookingDetail.CompanyAddress,
          TaxCode: this.BookingDetail.TaxCode,
          GuestEmailTakeInvoice: this.BookingDetail.GuestEmailTakeInvoice,
          GuestPhoneTakeInvoice: this.BookingDetail.GuestPhoneTakeInvoice,
          IdentityCardTakeInvoice: this.BookingDetail.IdentityCardTakeInvoice,
        },
        Type: 'LIST',
        ListBookingDetailId: this.listPayment.map(item => item.BookingDetailId)
      }
      this.disableButton = true
      const response = await booking.updateInfoEinvoiceBookingDetail(body)
      this.disableButton = false
      //this.showResToast(response)
      if (response.Status === '200') {
        await this.UpdateMultiEInvoice()
    }
    },
    async UpdateMultiEInvoice() {
    const body = {
        PaymentId: this.listPayment.map(item => item.Id),
    }
    this.disableButton = true;
    
    const bodyPublish = {
        PaymentId: this.listPayment.filter(item => item.Status == 'TEMPORARY').map(item => item.Id),
    }

    try {
        const res = await booking.api_UPM02B(bodyPublish);
        if (res.Status === '200') {
            const response = await booking.api_IPM09_PUBLISH_MULTI_EINVOICE_COURSE(body);
            this.showResToast(response);
        } else {
            this.showResToast(res);
        }

        // Đặt $nextTick bên trong hàm API
        this.$nextTick(() => {
            this.$bvModal.hide('modal-update-issue-multi-einvoice');
            this.$emit('event', { type: 'after-publish-multi-einvoice' });
        });
    } catch (error) {
        this.showResToast({ Status: '500', Message: 'Có lỗi xảy ra!' });
    } finally {
        this.disableButton = false;
    }
},

      async getConfigInfo_RCOM01() {
    const responseModule = await booking.getConfigInfo({ KeyGroup: 'MODULE' })
    if (responseModule.Status === '200') {
      this.fullNameDefaultVisitorNoInvoice = responseModule.Data.find(x => x.KeyCode === 'EINVOICE_BUYER_NAME_WHEN_NOT_GET_INVOICE').KeyValue
    }
  },
  async getCompanies_RCL01(OpenDateTime) {
    const response = await members.getCompanies({ OpenDateTime })
    if (response) {
      this.companies = response.Data.Client
    }
  },
      // async updateCaddyBook_RBK16() {
      //     let checkSelectCaddy = true
      //     for (const x of this.data) {
      //         if(x.BookingDetail.BookingDetailCaddy.filter(x => x.checked === true).length != x.BookingDetailService.length) {
      //             checkSelectCaddy = false
      //             break
      //         }
      //     }
      //     if(!checkSelectCaddy) {
      //         this.showToast('error', this.$t('golf_check_out_please_select_caddy_no_assignee_service'))
      //         return
      //     }
      //     for (let i = 0; i < this.data.length;i++) {
      //         const listCaddyDetail = this.data[i].BookingDetail.BookingDetailCaddy.filter(x => x.checked === true)
      //         listCaddyDetail.forEach(async (caddy,index) => {
      //             const body = {
      //                 CaddyId: caddy.CaddyId,
      //                 BookingDetailServiceId: this.data[i].BookingDetailService[index].Id
      //             }
      //             await booking.api_UBK16(body)
      //             if(i === this.data.length - 1 && index === listCaddyDetail.length - 1) {
      //                 this.$emit('event', {type: 'after-update-caddy'})
      //                 this.showToast('success', this.$t('golf_common_success'))
      //                 this.hideModal()
      //             }
      //         })
      //     }
      // },
      // checkSelectCaddyBalanceService(indexBK,indexCaddy) {
      //     let conut = 0
      //     this.data[indexBK].BookingDetail.BookingDetailCaddy.forEach((x,index) => {
      //         if(x.checked) {
      //             conut++
      //         }
      //     })
      //     if(this.data[indexBK].BookingDetailService.length < conut) {
      //         this.data[indexBK].BookingDetail.BookingDetailCaddy[indexCaddy].checked = false
      //         this.showToast('error', this.$t('golf_check_out_no_select_caddy_more_service'))
      //     }
      // }
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/variables/variables';
@import '@core/scss/vue/libs/vue-slider.scss';

:v-deep{

  .modal-content {
    background: #FFFFFF;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    // max-width: 600px !important; /* Điều chỉnh tùy ý */
    // width: 600px !important;


  }
  .b-table-sticky-header {
    overflow-y: auto !important;
    max-height: 85% !important;
  }
}
.header {
            display: flex;
            justify-content: space-between;
            padding-bottom: 1rem;
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
            padding-top: 0.6rem;
            .header-amount {
               
            }
        }
        .detail-invoice {
            // border-bottom: 1px solid #ddd;
            // padding-bottom: 8px; /* Tạo khoảng cách nhỏ giữa nội dung và border */
            height: 115px;
            overflow-y: auto; /* Bật scroll khi cần */
            .detail-invoice-item {
                font-size: 12px;
                padding-bottom: 5px;
            }
        }


.banned-background-color-primary {
background: rgba(17, 74, 159, 0.12);
}
.title-modal {
font-style: normal;
font-weight: 500;
font-size: 18px;
color: #114A9F;
line-height: 21px;
}
.content-body-modal {
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 18px;
}
.color-primary {
color: $primary ;
}
.form-group-einvoice{
width: 400px;
}
.span-header-info{
color: $primary !important;
font-size: 16px !important;
font-weight: bold !important;
}
.span-group-einvoice{
margin-right: 20px;
width: 100px;
.span-text-einvoice{
  margin-top: 9px !important;
}
}
.disabled {
background: rgba(193, 193, 193, 0.12)
}
</style>
